module.exports = __webpack_public_path__ + "img/product2.37654771.jpg";